import clsx from "clsx";
import moment from "moment";

import { makeStyles } from "@material-ui/core/styles";

import { Card, Grid, Typography } from "@material-ui/core";
import componentStylesGeneric from "assets/theme/views/admin/generic";
import PreviewData from "components/FormFields/PreviewData";
import { ConditionGuard } from "guards/ConditionGuard";

const useStylesGeneric = makeStyles(componentStylesGeneric);
const useStylesLocal = makeStyles((theme) => ({
  cardMobilePadding: {
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2),
    },
  },
  gridItem: {
    minWidth: 0,
  },
  previewRoot: {
    minWidth: 0,
    maxWidth: "100%",
  },
  previewTitle: {
    fontWeight: 300,
    fontSize: 16,
    maxWidth: "100%",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    [theme.breakpoints.down("sm")]: {
      fontSize: 14,
    },
  },
  previewSubtitle: {
    fontWeight: 600,
    fontSize: 14,
    maxWidth: "100%",
    overflowWrap: "anywhere",
    wordBreak: "break-word",
    whiteSpace: "normal",
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
    },
  },
}));

export const ContractApprovalRequestDetailsCard = ({ contractApprovalRequest, isDraft }) => {
  const classes = useStylesGeneric();
  const localClasses = useStylesLocal();

  const cancelationReason =
    contractApprovalRequest?.cancelationReason ?? contractApprovalRequest?.CancelationReason;
  const cancelationDate = contractApprovalRequest?.cancelationDate ?? contractApprovalRequest?.CancelationDate;
  const cancelationUser = contractApprovalRequest?.cancelationUser ?? contractApprovalRequest?.CancelationUser
  const isCanceled = !!cancelationDate;

  const statusSubtitle = isCanceled
    ? "CANCELADO"
    : contractApprovalRequest?.contractApprovalStatusDescription;

  const renderPreviewData = ({ title, subtitle }) => (
    <>
      <Typography variant="subtitle1" className={localClasses.previewTitle}>
        {title}
      </Typography>
      <Typography variant="body1" className={localClasses.previewSubtitle}>
        {subtitle || "-"}
      </Typography>
    </>
  );

  return (
    <Grid item xs={12} md={12}>
      <Card className={clsx(classes.cardRoot, localClasses.cardMobilePadding)}>
        <Grid container>
          <Grid item xs={12} md={isDraft ? 4 : 3} className={localClasses.gridItem}>
            <PreviewData
              className={localClasses.previewRoot}
              title="Data de Submissão"
              subtitle={contractApprovalRequest?.requestDate}
            >
              {renderPreviewData}
            </PreviewData>
          </Grid>
          <Grid item xs={12} md={isDraft ? 4 : 3} className={localClasses.gridItem}>
            <PreviewData className={localClasses.previewRoot} title="Nº de Pedido" subtitle={contractApprovalRequest?.requestNumber}>
              {renderPreviewData}
            </PreviewData>
          </Grid>
          <Grid item xs={12} md={isDraft ? 4 : 3} className={localClasses.gridItem}>
            <PreviewData
              className={localClasses.previewRoot}
              title="Estado"
              subtitle={statusSubtitle}
            >
              {renderPreviewData}
            </PreviewData>
          </Grid>
          <ConditionGuard condition={!isDraft}>
            <Grid item xs={12} md={3} className={localClasses.gridItem}>
              <PreviewData
                className={localClasses.previewRoot}
                title="Centro de Emprego"
                subtitle={
                  (!!contractApprovalRequest?.provinceDescription
                    ? contractApprovalRequest?.provinceDescription
                    : "-") +
                  " / " +
                  (!!contractApprovalRequest?.employmentCenterDescription
                    ? contractApprovalRequest?.employmentCenterDescription
                    : "-")
                }
              >
                {renderPreviewData}
              </PreviewData>
            </Grid>
          </ConditionGuard>

          <ConditionGuard condition={isCanceled}>
            <Grid item xs={12} md={3} className={localClasses.gridItem}>
              <PreviewData
                className={localClasses.previewRoot}
                title="Data de Cancelamento"
                subtitle={cancelationDate ? moment(cancelationDate).format("DD/MM/YYYY   HH:mm") : cancelationDate}
              >
                {renderPreviewData}
              </PreviewData>
            </Grid>

            <Grid item xs={12} md={3} className={localClasses.gridItem}>
              <PreviewData
                className={localClasses.previewRoot}
                title="Responsável Cancelamento"
                subtitle={cancelationUser}
              >
                {renderPreviewData}
              </PreviewData>
            </Grid>

            <Grid item xs={12} md={3} className={localClasses.gridItem}>
              <PreviewData
                className={localClasses.previewRoot}
                title="Motivo de Cancelamento"
                subtitle={cancelationReason}
              >
                {renderPreviewData}
              </PreviewData>
            </Grid>
          </ConditionGuard>
        </Grid>
      </Card>
    </Grid>
  );
};
